import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var NurseHatSvg = function NurseHatSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.7 13.112h2.232v1.371H12.7v2.206H11.31v-2.206H9.077v-1.371h2.233v-2.205h1.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.262 4.249H7.748L5.595 8.58c-1.03.414-2.02.929-2.956 1.54L2 10.599l3.683 9.65h12.643L22 10.541l-.451-.303a17 17 0 0 0-3.135-1.657zm.294 3.706-1.16-2.335H8.613l-1.16 2.335a17.1 17.1 0 0 1 4.552-.608 17.1 17.1 0 0 1 4.551.608m-9.91 10.923-2.951-7.799a15.7 15.7 0 0 1 8.309-2.36h.002a15.7 15.7 0 0 1 8.308 2.36l-2.952 7.799z",
    clipRule: "evenodd"
  }));
};
export var NurseHat = function NurseHat(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: NurseHatSvg
  }));
};